import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { hrms } from '../../services/api';
import Button from '../../components/common/Button';
import { theme } from '../../theme';

const inp = {
  width: '100%', padding: '0.5rem 0.75rem',
  border: `1px solid #374151`, borderRadius: '0',
  fontSize: '0.875rem', color: '#111', background: '#fff',
  outline: 'none', boxSizing: 'border-box',
};

const label = {
  fontSize: '0.775rem', fontWeight: 600, color: '#374151',
  display: 'block', marginBottom: '0.25rem',
};

const row = {
  display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: '0', borderBottom: '1px solid #d1d5db',
};

const cell = {
  padding: '0.625rem 0.75rem',
  borderRight: '1px solid #d1d5db',
};

const sectionHead = {
  background: '#1e3a5f', color: '#fff',
  fontSize: '0.8rem', fontWeight: 700,
  padding: '0.5rem 0.75rem', letterSpacing: '0.05em',
  borderBottom: '1px solid #d1d5db',
};

const radio = { display: 'flex', gap: '1.5rem', alignItems: 'center', paddingTop: '0.25rem' };

export default function EPFForm11() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: '', father_husband_name: '', relationship_type: 'Father',
    dob: '', gender: 'Male', marital_status: 'Unmarried',
    mobile: '', email: '', pan_number: '', aadhar_number: '',
    bank_account_number: '', bank_ifsc: '', bank_name: '',
    previous_epf_member: false, previous_pf_account: '', previous_employer_name: '', previous_exit_date: '',
    previous_eps_member: false, previous_eps_dob: '',
    international_worker: false, country_of_origin: '', passport_number: '', passport_validity: '',
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [existingId, setExistingId] = useState(null);

  useEffect(() => { loadExisting(); }, []);

  const loadExisting = async () => {
    try {
      const r = await hrms.getMyEPFDeclaration();
      if (r.data) {
        const d = r.data;
        setExistingId(d.id);
        setSubmitted(d.is_submitted);
        setForm({
          full_name: d.full_name || '',
          father_husband_name: d.father_husband_name || '',
          relationship_type: d.relationship_type || 'Father',
          dob: d.dob || '',
          gender: d.gender || 'Male',
          marital_status: d.marital_status || 'Unmarried',
          mobile: d.mobile || '',
          email: d.email || '',
          pan_number: d.pan_number || '',
          aadhar_number: d.aadhar_number || '',
          bank_account_number: d.bank_account_number || '',
          bank_ifsc: d.bank_ifsc || '',
          bank_name: d.bank_name || '',
          previous_epf_member: d.previous_epf_member || false,
          previous_pf_account: d.previous_pf_account || '',
          previous_employer_name: d.previous_employer_name || '',
          previous_exit_date: d.previous_exit_date || '',
          previous_eps_member: d.previous_eps_member || false,
          previous_eps_dob: d.previous_eps_dob || '',
          international_worker: d.international_worker || false,
          country_of_origin: d.country_of_origin || '',
          passport_number: d.passport_number || '',
          passport_validity: d.passport_validity || '',
        });
      }
    } catch {}
  };

  const set = (name, value) => setForm(p => ({ ...p, [name]: value }));
  const handleChange = e => set(e.target.name, e.target.value);

  const handleSave = async (submit = false) => {
    setLoading(true); setError('');
    try {
      const payload = {
        ...form,
        dob: form.dob || undefined,
        previous_exit_date: form.previous_exit_date || undefined,
        previous_eps_dob: form.previous_eps_dob || undefined,
        passport_validity: form.passport_validity || undefined,
        is_submitted: submit,
      };
      await hrms.saveEPFDeclaration(payload);
      if (submit) setSubmitted(true);
      navigate('/employee/dashboard');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Failed to save. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const readOnly = submitted;

  return (
    <div style={{ maxWidth: '900px', fontFamily: 'Arial, sans-serif' }}>

      {/* Page header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.25rem' }}>
        <Button variant="outlineGray" onClick={() => navigate('/employee/complete-profile')}>← Back</Button>
        {submitted && (
          <span style={{ background: '#DCFCE7', color: '#166534', borderRadius: 20, padding: '0.25rem 0.875rem', fontSize: '0.8rem', fontWeight: 600 }}>
            ✓ Submitted
          </span>
        )}
      </div>

      {error && (
        <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '0.5rem', padding: '0.75rem 1rem', marginBottom: '1rem', color: theme.danger, fontSize: '0.875rem' }}>
          ⚠️ {error}
        </div>
      )}

      {/* ── Government Form Template ── */}
      <div style={{ border: '2px solid #1e3a5f', background: '#fff' }}>

        {/* Form Header */}
        <div style={{ background: '#1e3a5f', padding: '0.875rem 1rem', textAlign: 'center' }}>
          <p style={{ color: '#fbbf24', fontSize: '0.75rem', margin: 0, letterSpacing: '0.1em' }}>EMPLOYEES' PROVIDENT FUND ORGANISATION</p>
          <h2 style={{ color: '#fff', margin: '0.25rem 0 0', fontSize: '1rem', fontWeight: 800, letterSpacing: '0.05em' }}>FORM 11 (NEW)</h2>
          <p style={{ color: '#93c5fd', fontSize: '0.7rem', margin: '0.25rem 0 0' }}>
            [Para 34 of the Employees' Provident Funds Scheme, 1952 | Para 4 of EPS 1995 | Para 9 of EDLI Scheme 1976]
          </p>
          <p style={{ color: '#fcd34d', fontSize: '0.75rem', margin: '0.375rem 0 0', fontWeight: 600 }}>DECLARATION FORM — NEW EMPLOYEE</p>
        </div>

        {/* Establishment info strip */}
        <div style={{ background: '#f0f4ff', borderBottom: '1px solid #d1d5db', padding: '0.5rem 0.75rem', display: 'flex', gap: '2rem', flexWrap: 'wrap', fontSize: '0.78rem' }}>
          <span><strong>Establishment Name:</strong> BonTon Softwares Pvt Ltd</span>
          <span><strong>Establishment Code:</strong> (to be filled by HR)</span>
        </div>

        {/* Section 1 — Personal */}
        <div style={sectionHead}>1. PERSONAL DETAILS</div>
        <div style={{ borderBottom: '1px solid #d1d5db' }}>
          <div style={row}>
            <div style={cell}>
              <span style={label}>Name of the Member (in Block Letters)</span>
              <input style={inp} name="full_name" value={form.full_name} onChange={handleChange} readOnly={readOnly} placeholder="FULL NAME" />
            </div>
            <div style={cell}>
              <span style={label}>Father's / Husband's Name</span>
              <input style={inp} name="father_husband_name" value={form.father_husband_name} onChange={handleChange} readOnly={readOnly} />
            </div>
            <div style={{ ...cell, borderRight: 'none' }}>
              <span style={label}>Relationship</span>
              <div style={radio}>
                {['Father', 'Husband'].map(v => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                    <input type="radio" name="relationship_type" value={v} checked={form.relationship_type === v}
                      onChange={handleChange} disabled={readOnly} />
                    {v}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div style={row}>
            <div style={cell}>
              <span style={label}>Date of Birth</span>
              <input style={inp} type="date" name="dob" value={form.dob} onChange={handleChange} readOnly={readOnly} />
            </div>
            <div style={cell}>
              <span style={label}>Sex</span>
              <div style={radio}>
                {['Male', 'Female', 'Other'].map(v => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                    <input type="radio" name="gender" value={v} checked={form.gender === v} onChange={handleChange} disabled={readOnly} />
                    {v}
                  </label>
                ))}
              </div>
            </div>
            <div style={{ ...cell, borderRight: 'none' }}>
              <span style={label}>Marital Status</span>
              <div style={radio}>
                {['Unmarried', 'Married', 'Widow/Widower'].map(v => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                    <input type="radio" name="marital_status" value={v} checked={form.marital_status === v} onChange={handleChange} disabled={readOnly} />
                    {v}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Section 2 — Contact & Identity */}
        <div style={sectionHead}>2. CONTACT &amp; IDENTITY DETAILS</div>
        <div style={{ borderBottom: '1px solid #d1d5db' }}>
          <div style={row}>
            <div style={cell}>
              <span style={label}>Mobile Number</span>
              <input style={inp} name="mobile" value={form.mobile} onChange={handleChange} readOnly={readOnly} placeholder="10-digit mobile" />
            </div>
            <div style={cell}>
              <span style={label}>Email ID</span>
              <input style={inp} name="email" type="email" value={form.email} onChange={handleChange} readOnly={readOnly} />
            </div>
            <div style={cell}>
              <span style={label}>Permanent Account Number (PAN)</span>
              <input style={{ ...inp, textTransform: 'uppercase' }} name="pan_number" value={form.pan_number} onChange={handleChange} readOnly={readOnly} placeholder="ABCDE1234F" maxLength={10} />
            </div>
            <div style={{ ...cell, borderRight: 'none' }}>
              <span style={label}>Aadhar Number</span>
              <input style={inp} name="aadhar_number" value={form.aadhar_number} onChange={handleChange} readOnly={readOnly} placeholder="XXXX XXXX XXXX" maxLength={14} />
            </div>
          </div>
        </div>

        {/* Section 3 — Bank */}
        <div style={sectionHead}>3. BANK ACCOUNT DETAILS (KYC)</div>
        <div style={{ borderBottom: '1px solid #d1d5db' }}>
          <div style={row}>
            <div style={cell}>
              <span style={label}>Bank Account Number</span>
              <input style={inp} name="bank_account_number" value={form.bank_account_number} onChange={handleChange} readOnly={readOnly} />
            </div>
            <div style={cell}>
              <span style={label}>IFSC Code</span>
              <input style={{ ...inp, textTransform: 'uppercase' }} name="bank_ifsc" value={form.bank_ifsc} onChange={handleChange} readOnly={readOnly} maxLength={11} />
            </div>
            <div style={{ ...cell, borderRight: 'none' }}>
              <span style={label}>Bank Name &amp; Branch</span>
              <input style={inp} name="bank_name" value={form.bank_name} onChange={handleChange} readOnly={readOnly} placeholder="Bank name (auto from IFSC)" />
            </div>
          </div>
        </div>

        {/* Section 4 — Previous Employment */}
        <div style={sectionHead}>4. DETAILS OF PREVIOUS EMPLOYMENT (if any)</div>
        <div style={{ borderBottom: '1px solid #d1d5db', padding: '0.75rem' }}>
          {/* EPF member */}
          <div style={{ marginBottom: '0.75rem' }}>
            <span style={{ ...label, display: 'inline' }}>a) Were you a member of EPF Scheme, 1952?&nbsp;&nbsp;</span>
            <div style={{ ...radio, display: 'inline-flex', gap: '1rem' }}>
              {[['true', 'Yes'], ['false', 'No']].map(([val, lbl]) => (
                <label key={val} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                  <input type="radio" checked={String(form.previous_epf_member) === val}
                    onChange={() => set('previous_epf_member', val === 'true')} disabled={readOnly} />
                  {lbl}
                </label>
              ))}
            </div>
          </div>
          {form.previous_epf_member && (
            <div style={{ ...row, marginBottom: '0.75rem', border: '1px solid #e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
              <div style={cell}>
                <span style={label}>PF Account No. (UAN)</span>
                <input style={inp} name="previous_pf_account" value={form.previous_pf_account} onChange={handleChange} readOnly={readOnly} placeholder="UAN / PF Account No." />
              </div>
              <div style={cell}>
                <span style={label}>Previous Employer Name</span>
                <input style={inp} name="previous_employer_name" value={form.previous_employer_name} onChange={handleChange} readOnly={readOnly} />
              </div>
              <div style={{ ...cell, borderRight: 'none' }}>
                <span style={label}>Date of Exit from Previous Employment</span>
                <input style={inp} type="date" name="previous_exit_date" value={form.previous_exit_date} onChange={handleChange} readOnly={readOnly} />
              </div>
            </div>
          )}
          {/* EPS member */}
          <div style={{ marginBottom: '0.75rem' }}>
            <span style={{ ...label, display: 'inline' }}>b) Were you a member of EPS, 1995?&nbsp;&nbsp;</span>
            <div style={{ ...radio, display: 'inline-flex', gap: '1rem' }}>
              {[['true', 'Yes'], ['false', 'No']].map(([val, lbl]) => (
                <label key={val} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                  <input type="radio" checked={String(form.previous_eps_member) === val}
                    onChange={() => set('previous_eps_member', val === 'true')} disabled={readOnly} />
                  {lbl}
                </label>
              ))}
            </div>
          </div>
          {form.previous_eps_member && (
            <div style={{ maxWidth: 280, border: '1px solid #e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{ ...cell, borderRight: 'none' }}>
                <span style={label}>Date of Birth as per EPS Records</span>
                <input style={inp} type="date" name="previous_eps_dob" value={form.previous_eps_dob} onChange={handleChange} readOnly={readOnly} />
              </div>
            </div>
          )}
        </div>

        {/* Section 5 — International Worker */}
        <div style={sectionHead}>5. INTERNATIONAL WORKER DETAILS</div>
        <div style={{ borderBottom: '1px solid #d1d5db', padding: '0.75rem' }}>
          <div style={{ marginBottom: '0.75rem' }}>
            <span style={{ ...label, display: 'inline' }}>Are you an International Worker?&nbsp;&nbsp;</span>
            <div style={{ ...radio, display: 'inline-flex', gap: '1rem' }}>
              {[['true', 'Yes'], ['false', 'No']].map(([val, lbl]) => (
                <label key={val} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', cursor: 'pointer' }}>
                  <input type="radio" checked={String(form.international_worker) === val}
                    onChange={() => set('international_worker', val === 'true')} disabled={readOnly} />
                  {lbl}
                </label>
              ))}
            </div>
          </div>
          {form.international_worker && (
            <div style={{ ...row, border: '1px solid #e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
              <div style={cell}>
                <span style={label}>Country of Origin</span>
                <input style={inp} name="country_of_origin" value={form.country_of_origin} onChange={handleChange} readOnly={readOnly} />
              </div>
              <div style={cell}>
                <span style={label}>Passport Number</span>
                <input style={{ ...inp, textTransform: 'uppercase' }} name="passport_number" value={form.passport_number} onChange={handleChange} readOnly={readOnly} />
              </div>
              <div style={{ ...cell, borderRight: 'none' }}>
                <span style={label}>Passport Validity</span>
                <input style={inp} type="date" name="passport_validity" value={form.passport_validity} onChange={handleChange} readOnly={readOnly} />
              </div>
            </div>
          )}
        </div>

        {/* Declaration */}
        <div style={{ padding: '0.875rem 0.75rem', borderBottom: '1px solid #d1d5db', background: '#fafafa', fontSize: '0.78rem', color: '#374151', lineHeight: 1.6 }}>
          <strong>DECLARATION:</strong> I hereby declare that the information furnished above is true and correct to the best of my knowledge and belief.
          I undertake to inform the employer of any change in the above information.
          I am aware that furnishing false information is liable for prosecution.
        </div>

        {/* Signature block */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '1rem 0.75rem', gap: '2rem' }}>
          <div>
            <p style={{ fontSize: '0.78rem', color: '#374151', margin: 0 }}>Date: _______________</p>
            <p style={{ fontSize: '0.78rem', color: '#374151', marginTop: '0.5rem' }}>Place: _______________</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ borderBottom: '1px solid #374151', width: 200, marginLeft: 'auto', marginBottom: '0.25rem', height: 40 }} />
            <p style={{ fontSize: '0.78rem', color: '#374151', margin: 0 }}>Signature of the Employee</p>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      {!readOnly && (
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', paddingTop: '1.25rem', paddingBottom: '2rem' }}>
          <Button variant="outlineGray" onClick={() => handleSave(false)} loading={loading}>Save Draft</Button>
          <Button variant="primary" onClick={() => handleSave(true)} loading={loading}>Submit Declaration</Button>
        </div>
      )}
      {readOnly && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1.25rem', paddingBottom: '2rem' }}>
          <Button variant="outlineGray" onClick={() => navigate('/employee/dashboard')}>Back to Dashboard</Button>
        </div>
      )}
    </div>
  );
}
